import styled from 'styled-components';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';

interface ContainerProps {
  readonly $isOpen: boolean
}

export const StyledContainer = styled.div<ContainerProps>`
  flex: 0 0 300px;
  background-color: #F0F0F0;
  height: 92vh;
  border-left: 8px solid black;
  position: relative;  
  margin-right: ${(props) => props.$isOpen ? '0' : '-218px'}; // WHEN CLOSE, IT MUST LEAVE 82px
  transition: all .1s linear;
`;

export const StyledButtonContainer = styled.span`
  position: absolute;
  left: 0;
  top: 50%;
  padding: 0;
  margin: 0;
  display: block;
  background-color: black;
  width: 20px;
  height: 130px; 
  display: flex;
  justify-content: center;
  align-items: center; 
  z-index: 500;
  &:hover {
    cursor: pointer;
  }

`;

export const StyledDoubleArrowIcon = styled(DoubleArrowIcon)<ContainerProps>`

  && {
    color: white;
    margin: 0;
    margin-right: 5px;
    font-size: 20px;
    transform: ${(props) => props.$isOpen ? '' : 'rotate(180deg)'};
  }    

`;
